import './functions';
import './variables';
import './reducers';
import { wrapperBuilder } from './build';

export const AnotherTestingWrapper = wrapperBuilder.build();
